import React, {Component} from 'react';
import {Typography, withStyles} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import CssBaseline from '@material-ui/core/CssBaseline';
import ExcelViewer from './ExcelViewer';
import PDFViewer from './PDFViewer';
import ImageViewer from './ImageViewer';
import i18n from '../../i18n';
import RenderDetailsRow from '../Formater/RenderDetailsRow';
import Modal from '@material-ui/core/Modal';
import List from '@material-ui/core/List/List';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from "@material-ui/core/Fab";

const vspacing = 20;

class FileViewer extends Component {
    constructor(props) {
        super(props);

        this.navBar = React.createRef();
        this.doPage = null;

        let withSpacing = this.props.renderer === 'pdf';

        this.state = {
            withSpacing: withSpacing,
            numPages: 1,
            pageNumber: 1,
            pageWidth: 100,
            cbResize: null,
            renderer: this.props.renderer,
            fileConfig: this.props.fileConfig,
            showDetails: false,
        };

    }

    onDocumentLoadSuccess = ({numPages}) => {
        this.setState({numPages});
    };

    getNavBarHeight = () => {
        return this.navBar && this.navBar.current ? this.navBar.current.clientHeight : 0;
    };

    updateDimensions = () => {
        let state = {
            pageWidth: window.innerWidth - (this.state.withSpacing ? (vspacing * 2.5) : 0),
            pageHeight: window.innerHeight - this.getNavBarHeight() - (this.state.withSpacing ? (vspacing * 2.5) : 0),
        };
        this.setState(state);
        if (this.cbResize) {
            this.cbResize(state.pageWidth, state.pageHeight);
        }
    };

    componentDidMount = () => {
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);
    };
    componentWillUnmount = () => {
        window.removeEventListener('resize', this.updateDimensions);
    };

    renderDetails() {
        const {classes} = this.props;
        return (
            <React.Fragment>
                <Tooltip title={i18n.get('file.details.tooltip')} aria-label="previous_version">
                    <Fab color="primary" aria-label="left"
                            className={classes.fab}
                            onClick={() => {
                                this.setState({showDetails: true});
                            }}>
                        <Icon>help_outline</Icon>
                    </Fab>
                </Tooltip>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.showDetails}
                    onClose={() => {
                        this.setState({showDetails: false});
                    }}
                >
                    <div className={classes.modalPaper}>
                        <RenderDetailsRow label={i18n.get('file.details.name')} value={this.state.fileConfig.sName}/>
                        <RenderDetailsRow label={i18n.get('file.details.uploaded')} value={this.state.fileConfig.sCreated}/>
                        <RenderDetailsRow label={i18n.get('file.details.uploadedBy')} value={this.state.fileConfig.oCreator && this.state.fileConfig.oCreator.name}/>
                        <RenderDetailsRow label={i18n.get('file.details.copies')} value={this.state.fileConfig.iCopies}/>
                        <RenderDetailsRow label={i18n.get('file.details.tag.input.placeholder')} value={this.state.fileConfig.sTags}/>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }

    render() {
        const {pageNumber, numPages} = this.state;
        const {classes} = this.props;

        return (
            <React.Fragment>
                <CssBaseline/>
                {this.state.renderer === 'image' && (
                    <Grid item xs={12} className={classes.image}>
                        <Grid container spacing={0}
                              direction="row"
                              justify="center"
                              alignItems="center"
                              style={{minHeight: this.state.pageHeight}}
                        >
                            <ImageViewer
                                filename={this.props.filename}
                                width={this.state.pageWidth}
                                height={this.state.pageHeight}
                            />
                        </Grid>
                    </Grid>
                )}
                {this.state.renderer === 'xlsx' && (
                    <div className={classes.excel}>
                        <ExcelViewer
                            filename={this.props.filename}
                            pageNumber={pageNumber}
                            doResize={(cb) => {
                                this.cbResize = cb;
                            }}
                            width={this.state.pageWidth}
                            height={this.state.pageHeight}
                        />
                    </div>
                )}
                {this.state.renderer === 'pdf' && (
                    <PDFViewer
                        filename={this.props.filename}
                        pageNumber={pageNumber}
                        doResize={(cb) => {
                            this.cbResize = cb;
                        }}
                        doPage={(cb) => {
                            this.doPage = cb;
                        }}
                        width={this.state.pageWidth}
                        height={this.state.pageHeight}
                        onDocumentLoadSuccess={this.onDocumentLoadSuccess}
                    />
                )}
                <BottomNavigation className={classes.stickToBottom} showLabels={true}>
                    <div ref={this.navBar} className={classes.fullWidth}>
                        <Grid container spacing={8}>
                            <Grid item xs={2} md={1}>
                                {this.state.fileConfig.sRoutePreviewPreviousVersion && (
                                    <Tooltip title={i18n.get('file.previous_version')} aria-label="previous_version">
                                        <Fab color="primary" aria-label="left"
                                                className={classes.fab}
                                                onClick={() => {
                                                    window.location.href = this.state.fileConfig.sRoutePreviewPreviousVersion;
                                                }}>
                                            <Icon>skip_previous</Icon>
                                        </Fab>
                                    </Tooltip>
                                )}
                            </Grid>
                            <Grid item xs={2} md={1}>
                                {this.renderDetails()}
                            </Grid>
                            <Grid item xs={5} md={8} className={classes.center}>
                                {this.state.renderer !== 'image' && numPages > 1 && (<React.Fragment>
                                    <Tooltip title={i18n.get('file.previous_page')}>
                                        <Fab color="primary" aria-label="left"
                                                className={classes.fab}
                                                disabled={!(pageNumber > 1)}
                                                onClick={() => {
                                                    this.setState({pageNumber: pageNumber - 1});
                                                    if (this.doPage) {
                                                        this.doPage(pageNumber - 1);
                                                    }
                                                }}>
                                            <Icon>chevron_left</Icon>
                                        </Fab>
                                    </Tooltip>
                                    <span className={classes.pageNav}>{pageNumber} / {numPages}</span>
                                    <Tooltip title={i18n.get('file.next_page')}>
                                        <Fab color="primary" aria-label="right"
                                                className={classes.fab}
                                                disabled={!(numPages > 1 && pageNumber < numPages)}
                                                onClick={() => {
                                                    this.setState({pageNumber: pageNumber + 1});
                                                    if (this.doPage) {
                                                        this.doPage(pageNumber + 1);
                                                    }
                                                }}>
                                            <Icon>chevron_right</Icon>
                                        </Fab>
                                    </Tooltip>
                                </React.Fragment>)}
                            </Grid>
                            <Grid item xs={3} md={2}>
                                <Tooltip title={i18n.get('file.download')} aria-label="Add">
                                    <a href={this.props.filename} className={classes.downloadButton}>
                                        <Fab color="primary" aria-label="left"
                                                className={classes.downloadButton}>
                                            <Icon className={classes.iconSpace}>cloud_download</Icon>
                                        </Fab>
                                    </a>
                                </Tooltip>
                                {this.state.fileConfig.sRoutePreviewNextVersion && (
                                    <Tooltip title={i18n.get('file.next_version')} aria-label="Add">
                                        <Fab color="primary" aria-label="left"
                                                className={classes.fab}
                                                onClick={() => {
                                                    window.location.href = this.state.fileConfig.sRoutePreviewNextVersion;
                                                }}>
                                            <Icon>skip_next</Icon>
                                        </Fab>
                                    </Tooltip>
                                )}
                            </Grid>
                        </Grid>
                    </div>
                </BottomNavigation>
            </React.Fragment>
        );
    }
}


const styles = theme => ({
    span: {
        display: 'inline',
    },
    space: {
        paddingRight: theme.spacing.unit * 3,
    },
    left: {
        textAlign: 'center',
        paddingRight: theme.spacing.unit * 3,
    },
    right: {
        textAlign: 'center',
    },
    center: {
        textAlign: 'center',
    },
    fab: {
        padding: theme.spacing.unit,
    },
    page: {
        textAlign: 'center',
    },
    pageNav: {
        padding: theme.spacing.unit * 2,
    },
    excel: {
        backgroundColor: theme.colors.white,
    },
    document: {
        paddingLeft: vspacing,
        paddingTop: vspacing,
    },
    fullWidth: {
        width: '100%',
    },
    stickToBottom: {
        backgroundColor: theme.colors.lightGreyBlue,
        width: '100%',
        position: 'fixed',
        bottom: 0,
        paddingBottom: vspacing,
    },
    shortDetail: {
        fontSize: 12,
    },
    modalPaper: {
        position: 'absolute',
        width: 500,
        top: '50%',
        left: '50%',
        marginTop: -70,
        marginLeft: -250,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        outline: 'none',
    },
});


export default withStyles(styles)(FileViewer);
